module.exports = __webpack_public_path__ + "img/jpg.a48e42b8.svg";